export function validateOrderRows($table) {
    var $form = $table.closest('form');

    if (
        !$table.find('tr.error').length &&
        $table.find('.multi-order-brand').length > 1
    ) {
        $form.find('button[type="submit"]').prop('disabled', false);
        if (!$table.find('tr.no-inst').length) {
            $form.find('.instant-order').prop('disabled', false);
            $form.find('.instant-order').attr('title', '');
        } else {
            $form.find('.instant-order').prop('disabled', true);
            $form
                .find('.instant-order')
                .attr(
                    'title',
                    'Instant Ordering Unavailable: Your default warehouse has no inventory. Add to Order to select a location.'
                );
        }
    } else {
        $form.find('button[type="submit"]').prop('disabled', true);
        $form.find('.instant-order').prop('disabled', true);
        $form
            .find('.instant-order')
            .attr('title', 'Instant Ordering Unavailable.');
    }
}

export function renameOrderRows($table) {
    var idx = 0;
    // Body rows only — thead <tr> was consuming index 0, shifting items[n] and breaking POST shape.
    $table.find('tbody tr').each(function () {
        var $iteratedRow = $(this);

        if ($iteratedRow.hasClass('default-row')) {
            $iteratedRow
                .find('.multi-order-brand, .multi-order-part-number, .multi-order-quantity, .multi-order-gtin')
                .removeAttr('name');
            return;
        }

        $iteratedRow
            .find('.multi-order-brand')
            .attr('name', 'items[' + idx + '][AAIABrandCode]');
        $iteratedRow
            .find('.multi-order-part-number')
            .attr('name', 'items[' + idx + '][PartNumber]');
        $iteratedRow
            .find('.multi-order-quantity')
            .attr('name', 'items[' + idx + '][Quantity]');
        idx++;
    });
}
